var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileUrl && _vm.thumbnail)?_c('video',{staticClass:"video-tag",attrs:{"src":_vm.fileUrl,"width":"100%","playsinline":"","muted":"","autoplay":_vm.getOS() == 'iOS' ? false : true,"controls":"","controlsList":"nodownload noremoteplayback","poster":_vm.thumbnail},domProps:{"muted":true}},[_vm._v(" Invalid video ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }